import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/web-portal/web_portal_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "10px" }}>
                Custom Web Portal Development Company in USA
              </h1>
              <p>
                TekRevol has transformed visionary concepts into fully
                functional, user-friendly web portals for 5+ years. Our web
                portal development services are designed to cater to your unique
                needs by delivering a custom solution that drives your business
                forward.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get a Quote
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
